<template>
  <div>
    <div>
      <div :class="generatorMainSectionClass">

        <div :class="generatorTableSectionClass">

          <SlidingSearchPanel
              :position="this.layout === 'horizontal' ? 'left' : 'top'"
              topOffset="64px"
              leftOffset="250px"
              panelWidth="1000px"
              handleColor="bg-primary"
          >

            <SearchBar2
                :searchOptions="fieldsAvailableForSearch"
                @searchRequest="searchOnList($event)"
            />
          </SlidingSearchPanel>
          <CommonDataPanel v-if="!selectionOnlyMode" :key="dataPanelData" :data="dataPanelData"
                           :headers="dataPanelHeaders" titleKey="orderName"
                           @onTriggerAction="runAction($event)"
                           @onTriggerValue="onTriggerDataPanelValue($event)"
          />


          <CommonTable2
              :table="tableData"
              rowIdentifier="guid"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              @onSelectRow="selectRow($event)"
              @onEnterRowSelected="editOrderGeneratorView"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="packagesModule.getPackageOrdersTotal"
              :totalPages="packagesModule.getPackageOrdersPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              :multiselect="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :showMassActions="!selectionOnlyMode"
              :showRowActions="!selectionOnlyMode"
              :initiallyCheckedItemsData="selectedItems"
              :initiallyVisibleColumns="initialVisibleColumns"
          >

            <template #table-related-buttons>
              <!--              <button class="btn btn-outline-secondary shadow-sm" @click="showColumnManager = true" title="Zarządzaj kolumnami">-->
              <!--                <i class="fas fa-columns"></i>-->
              <!--              </button>-->

              <button
                  type="submit"
                  id="open-save-order-from-file-extended-btn"
                  @click="openOrdersGeneratorForm()"
                  class="d-none d-sm-inline-block btn btn-sm btn-outline-success shadow-sm"
                  style="margin-right: 4px;"
              >
                <i class="bx bx-plus-circle"/>
                Utwórz zamówienie [F2]
              </button>

              <!--              <button-->
              <!--                  type="submit"-->
              <!--                  id="open-save-order-from-file-extended-btn"-->
              <!--                  @click="openOrdersFromFileExtendedForm()"-->
              <!--                  class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"-->
              <!--              >-->
              <!--                <i class="bx bx-cloud-download align-middle font-size-16"/>-->
              <!--                Importuj plik z zamówieniem-->
              <!--              </button>-->

            </template>


          </CommonTable2>
        </div>

        <slot name="bottom"></slot>

        <PackageOrderImportAssistant
            v-if="showOrderImportFromFileExtendedForm"
            :showModal="showOrderImportFromFileExtendedForm"
            @closeModal="showOrderImportFromFileExtendedForm = false"
            @refreshOrdersList="refreshPackageOrdersList()"
        />

        <b-modal
            v-model="showSendMailModal"
            id="send-payment-doc-email-form-modal"
            scrollable
            :title=mailContent.sendMailDialogTitle
            title-class="font-18"
            size="xl"
            style="z-index:100010!important;"
            hide-footer


        >
          <b-alert
              v-model="showSendMailAlert"
              :variant="sendMailAlertType"
              class="mt-3"
              dismissible
          >{{ sendMailAlertContent }}
          </b-alert
          >

          <div class="form-group">

            <CommonEmailSendMessageForm
                :mailMessage="mailContent.mailMessage"
                :mailSubject="mailContent.mailSubject"
                :mailTo="mailContent.mailTo"
                :mailCc="mailContent.mailCc"
                :mailAttachmentName="mailContent.mailAttachmentName"
                @onCancelMail="showSendMailModal = false"
                @onSendMail="sendEmailWithPackageOrderData"
                :key="mailContent"


            />


          </div>


        </b-modal>

        <PackageOrderGeneratorAssistantModal @onSuccessOrderCreation="handleSuccessOrderCreation"
                                             v-if="showOrderCreationAssistantFormModal"
                                             v-model:showModal="showOrderCreationAssistantFormModal"/>


        <PackageOrderFormModal :showModal="showOrderDetailsModal"
                               ref="orderDetailsModalRef"
                               @update:showModal="closeDetailsModal($event)"
                               @onSave="saveOrder"
                               :key="currentEditedGroupOrder"
                               :initialPackageOrderData="currentEditedGroupOrder"
        />


      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import FloationgBackButton from "@/components/widgets/FloatingBackButton.vue";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import PackageOrderImportAssistant from "@/views/PackagesManager/PackageOrderImportAssistant.vue";
import {log} from "@/state/pinia/log";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {commonAppHelperMethods} from "@/views/DrugstoreCommonManager/helper/commonAppHelperMethods";
import {packagesHelperMethods} from "@/views/PackagesManager/helper/packagesHelperMethods";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import CommonEmailSendMessageForm from "@/components/widgets/CommonEmailSendMessageForm.vue";
import PackageOrderFormModal from "@/views/PackagesManager/PackageOrderFormModal.vue";
import {useLayoutStore} from "@/state/pinia";
import CommonDataPanel from "@/components/widgets/CommonDataPanel.vue";
import SlidingSearchPanel from "@/components/widgets/SlidingSearchPanel.vue";
import PackageOrderGeneratorAssistantModal from "@/views/PackagesManager/PackageOrderGeneratorAssistantModal.vue";
import router from "@/router";

export default {
  name: "PackagesManagerOrdersCentralListGrouped",
  components: {
    PackageOrderGeneratorAssistantModal,
    SlidingSearchPanel,
    CommonDataPanel,
    PackageOrderFormModal,
    CommonEmailSendMessageForm,
    CommonTable2,
    PackageOrderImportAssistant,
    SearchBar2
  },
  props: {
    selectionOnlyMode: {type: Boolean, default: false},
    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },

  },
  emits: ["onSelectRow"],

  data() {
    return {
      tableData: {},
      packageOrders: [],
      showOrderImportFromFileExtendedForm: false,
      selectedItems: [],
      showOrderDetailsModal: false,
      currentEditedGroupOrder: null,
      selectedOrderName: null,
      sortingDirection: "DESC",
      sortingKey: "id",
      currentPage: 1,
      showOrderCreationAssistantFormModal: false,
      searchRequest: {
        searchPhrase: "",
        searchKey: "",
      },
      refreshTable: true,
      mailContent: {
        sendMailDialogTitle: "",
        mailMessage: "",
        mailSubject: "",
        mailTo: "",
        mailCc: "",
        mailAttachmentName: ""
      },

      showSendMailModal: false,
      showSendMailAlert: false,
      sendMailAlertType: "warning",
      sendMailAlertContent: "",
      currentGroupOrderToSend: null,

      tableMassActions: [
        {
          text: "Usuń zaznaczone [F8]",
          icon: "fas fa-trash-alt",
          action: "delete-orders",
          class: "btn btn-danger table-actions-button",
          enabled: true,
          tooltip: "Usuń zaznaczone zamówienia",
        },
      ],

      fieldsAvailableForSearch: [
        {
          name: "Nazwa zamówienia",
          key: "orderName", // Mapped to type 0
        },
        {
          name: "Nazwa pozycji",
          key: "itemName", // Mapped to type 1
        },
        {
          name: "Numer bloz pozycji",
          key: "itemBloz", // Mapped to type 2
        },
      ],

      availableHeaders: [
        {
          text: "ID",
          key: "id",
          type: "number",
          sortable: true,
          style: "width: 70px;text-align:left!important;",
        },
        {
          text: "Symbol zamówienia",
          key: "orderReference",
          type: "text",
          sortable: true,
          style: "width: 64px;text-align:left!important;",

        },
        {
          text: "Data zam.",
          key: "orderCreationDate",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          style: "width: 68px;text-align:left!important;",
        },

        {
          text: "Nazwa",
          key: "orderName",
          type: "text",
          sortable: true,

        },
        {
          text: "Prospekt",
          key: "doCreateProspect",
          type: "boolean",
          sortable: true,
          style: "width: 60px;text-align:left!important;",
        },
        {
          text: "Data ważności prospektu",
          key: "prospectExpiryDate",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          style: "width: 90px;text-align:left!important;",
        },
        // {
        //   text: "Dod.poz. do prospektu",
        //   key: "prospectAllowAddProducts",
        //   type: "boolean",
        //   sortable: true,
        //   style: "width: 60px;text-align:left!important;",
        // },
        {
          text: "Data zak. prospektu",
          key: "prospectCloseDate",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          style: "width: 90px;text-align:left!important;",
        },
        //
        // {
        //   text: "Cena zak. prospektu",
        //   key: "prospectAllowPurchasePrice",
        //   type: "boolean",
        //   sortable: true,
        // },


        {
          text: "Dostawca",
          key: "supplierName",
          type: "text",
          sortable: true,

          style: "width: 192px;",
        },
        {
          text: "Producent",
          key: "producer",
          type: "text",
          sortable: false,

        },

        // {
        //   text: "Pracownik",
        //   key: "userId",
        //   type: "text",
        //   sortable: true,
        // },

        {
          text: "Status zamówienia",
          key: "orderStatus",
          type: "text",
          sortable: true,
          style: "width: 120px;text-align:left!important;",

        },
        {
          text: "Stan realizacji",
          key: "realisationLevel",
          type: "progress",
          sortable: true,
          style: "width: 160px;text-align:left!important;",
        },
        // {
        //   text: "Ilość pozycji",
        //   key: "orderUnitsAmount",
        //   type: "number",
        //   sortable: true,
        // },
        {
          text: "Wart. netto",
          key: "orderValueTaxExcluded",
          type: "currency",
          sortable: true,
          style: "width: 90px;text-align:left!important;",

        },
        {
          text: "Wart. brutto",
          key: "orderValueTaxIncluded",
          type: "currency",
          sortable: true,
          style: "width: 90px;text-align:left!important; ",

        },
        {
          text: "Wysłano",
          key: "sentAt",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          style: "width: 90px;text-align:left!important;",
        },
        {
          text: "Dostarczono",
          key: "deliveredAt",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          style: "width: 90px;text-align:left!important;",

        },

        {
          text: "Uwagi",
          key: "notifications",
          type: "text",
          sortable: true,
          style: "width: 196px;text-align:left!important;",

        },
        {
          text: "Utworzone przez",
          key: "creator",
          type: "text",
          sortable: false,
          style: "width: 80px;",

        },
        // {
        //   text: "Okres zatowarowania",
        //   key: "targetSupplyDays",
        //   type: "number",
        //   sortable: true,
        // },


        // {
        //   text: "Akcje",
        //   key: "actions",
        //   type: "actions",
        //   style: "width: 48px;",
        //   actions: [
        //     // {
        //     //   text: "Apteki",
        //     //   icon: "fas fa-list",
        //     //   action: "drugstores-realisation-details",
        //     //   enabled: true,
        //     //   tooltip: "Stan realizacji zamówienia w aptekach",
        //     //   class: "btn btn-info btn-sm table-actions-button edit-button",
        //     // },
        //     // {
        //     //   text: "",
        //     //   icon: "fas fa-file-invoice",
        //     //   action: "view-details",
        //     //   enabled: true,
        //     //   tooltip: "Zobacz szczegóły nagłówkowe zamówienia",
        //     //   class: "btn btn-info table-actions-button edit-button",
        //     // },
        //     //
        //     // {
        //     //   text: "",
        //     //   icon: "fas fa-edit",
        //     //   action: "go-to-order-generator",
        //     //   enabled: true,
        //     //   tooltip: "Przejdź do generatora zamówienia",
        //     //   class: "btn btn-info table-actions-button edit-button",
        //     // },
        //     //
        //     // {
        //     //   text: "",
        //     //   icon: "fas fa-paper-plane",
        //     //   action: "send-orders-to-drugstores",
        //     //   enabled: true,
        //     //   tooltip: "Wyslij maila z powiadomieniem o nadchodzącym zamówieniu centralnym do aptek",
        //     //   class: "btn btn-primary table-actions-button",
        //     // },
        //     //
        //     // {
        //     //   text: "",
        //     //   icon: "mdi mdi-content-copy",
        //     //   action: "create-copy-of-order",
        //     //   enabled: true,
        //     //   tooltip: "Utwórz kopię tego zamówienia",
        //     //   class: "btn btn-primary table-actions-button",
        //     // },
        //
        //
        //     // {
        //     //   text: "",
        //     //   icon: "fas fa-trash",
        //     //   action: "delete-order",
        //     //   enabled: true,
        //     //   tooltip: "Usuń",
        //     //   class: "btn btn-danger btn-sm table-actions-button edit-button",
        //     // },
        //   ],
        // },
      ],
      dataPanelData: null,
      dataPanelHeaders: [
        {text: "Opublikowano", key: "isCentral", type: "boolean", isMeta: true},
        {text: "Data publikacji", key: "publishedAt", type: "date", isMeta: true, isEpochMillis: true},
        {text: "Symbol zamówienia", key: "orderReference", type: "text", isMeta: true},
        // {
        //   text: "Dostawca",
        //   key: "supplierName",
        //   type: "text",
        //   isMeta: true
        // },
        // {
        //   text: "Ilość pozycji",
        //   key: "orderUnitsAmount",
        //   type: "number",
        //   isMeta: true
        // },
        // {
        //   text: "Okres zatowarowania",
        //   key: "targetSupplyDays",
        //   type: "number",
        //   isMeta: true
        // },

        // --- ACTION BAR (prawa strona nagłówka) ---


        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          actions: [
            {
              text: "Generator [Ent]",
              icon: "fas fa-edit",
              action: "go-to-order-generator",
              enabled: true,
              tooltip: "Przejdź do generatora zamówienia",
              class: "btn btn-success table-actions-button edit-button",
              style: "margin-right: 4px;",
            },

            {
              type: "button",
              text: "Dane nagłówkowe [F3]",
              icon: "fas fa-file-invoice",
              action: "view-details",
              enabled: true,
              tooltip: "Zobacz szczegóły nagłówkowe zamówienia",
              class: "btn btn-info table-actions-button edit-button",
              style: "margin-right: 4px;",
            },
            {
              text: "Realizacja w aptekach [F4]",
              icon: "fas fa-list",
              action: "drugstores-realisation-details",
              enabled: true,
              tooltip: "Stan realizacji zamówienia w aptekach",
              style: "margin-right: 4px;",
              class: "btn btn-primary btn-sm table-actions-button edit-button",
            },
            {
              type: "button",
              text: "Duplikuj zamówienie [F5]",
              icon: "mdi mdi-content-copy",
              action: "create-copy-of-order",
              enabled: true,
              tooltip: "Utwórz kopię tego zamówienia",
              style: "margin-right: 4px;",
              class: "btn btn-primary table-actions-button",
            },
            {
              type: "button",
              text: "Wyślij zamówienie mailem [F6]",
              icon: "fas fa-paper-plane",
              action: "send-orders-to-drugstores",
              enabled: true,
              style: "margin-right: 4px;",
              tooltip: "Wyslij maila z powiadomieniem o nadchodzącym zamówieniu centralnym do aptek",
              class: "btn btn-primary table-actions-button",
            },


            {
              type: "button",
              text: "Usuń [F7]",
              icon: "fas fa-trash",
              action: "delete-order",
              enabled: true,
              tooltip: "Usuń zamówienie",
              class: "btn btn-danger btn-sm table-actions-button edit-button",
            },


          ]
        },

      ]

    };
  },
  computed: {
    packagesModule() {
      return usePackagesManagerModule();
    },
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    isViewValid() {
      return this.commonModule.centralInstance === true;
    },
    layoutStore() {
      return useLayoutStore();
    },

    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }

    },

    generatorTableSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'generator-table-container-vertical windows-like-breadcrumb-card shadow-sm scrollable-container';
      } else {
        return 'generator-table-container windows-like-breadcrumb-card shadow-sm scrollable-container';
      }
    },
    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row package-orders-generator-site';
      } else {
        return 'package-orders-generator-site';
      }
    },

    initialVisibleColumns() {
      var availableColKeys = this.availableHeaders.map(header => header.key);
      for (let i = 0; i < availableColKeys.length; i++) {
        const key = availableColKeys[i];
        if (key === "producer" || key === "deliveredAt" || key === "sentAt"  || key === "id") {
          availableColKeys.splice(i, 1);
          i--;
        }
      }

      return availableColKeys;

    },

  },
  methods: {

    handleSuccessOrderCreation(createdOrder) {
      Swal.fire({
        title: "Sukces",
        text: "Zamówienie zostało pomyślnie utworzone. Czy chcesz przejść do edycji nowo utworzonego zamówienia?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
      }).then((result) => {
        if (result.value) {
          // Go to order edit mode
          this.$router.push({
            name: 'PackagesManagerOrdersGeneratorStage',
            query: {editOrderGroupGuid: createdOrder.groupGuid}
          })

        } else {
          // Just refresh the list
          this.refreshPackageOrdersList();
        }
      });
    },
    openOrdersGeneratorForm() {
      this.showOrderCreationAssistantFormModal = true;
    },
    openOrdersFromFileExtendedForm() {
      this.showOrderImportFromFileExtendedForm = true;
    },

    sort(sortKey) {
      if (this.sortingKey === sortKey) {
        this.toggleSortingDirection();
      } else {
        this.sortingKey = sortKey;
        // Default new sort to DESC for compatibility or ASC? Original toggles.
        this.sortingDirection = "ASC";
      }
      this.refreshPackageOrdersList();
    },
    toggleSortingDirection() {
      this.sortingDirection = this.sortingDirection === "ASC" ? "DESC" : "ASC";
    },
    checkAction(event) {
      // event.itemsData contains array of checked items identifiers
      this.selectedItems = event.itemsData;
      this.$emit("onCheckItem", event)
    },
    selectRow(event) {
      // event.itemData contains data of selected row
      console.log("Selected row data: ", event);

      this.dataPanelData = event
      this.$emit("onSelectRow", event)
    },
    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.currentPage = 1;
      this.refreshPackageOrdersList();
    },
    runAction(event) {
      const action = event.action.action;
      const order = event.itemData;

      if (action === "drugstores-realisation-details") {
        this.goToOrderRealisationView(order);
      } else if (action === "view-details") {
        this.openOrderDetailsModal(order.groupGuid);
      } else if (action === "go-to-order-generator") {
        this.editOrderGeneratorView(order);
      } else if (action === "send-orders-to-drugstores") {
        this.exportAndSendEmail(order.groupGuid);
      } else if (action === "create-copy-of-order") {
        // show warning before
        this.copyExistingOrderToNewWitWarning(order)


      } else if (action === "publish-order") {
        const buttonElementRef = event.elementRef;
        this.openShareForm(order, buttonElementRef);
      } else if (action === "delete-order") {
        this.removeOrders(order.groupGuid, false, this.commonModule.centralInstance);

      }
    },
    copyExistingOrderToNewWitWarning(sourceOrder) {
      return Swal.fire({
        title: "Utworzyć kopię zamówienia?",
        text: `Czy na pewno chcesz utworzyć kopię zamówienia "${sourceOrder.orderName}"? Proces może potrwać kilka minut.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        dangerMode: true,
      }).then((proceed) => {
        if (proceed.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Kopiowanie zamówienia pakietowego...");

          return this.packagesModule.httpCopyExistingOrderToNew({
            orderGroupGuid: sourceOrder.groupGuid,
            onFinishedCallback: this.refreshGroupedOrdersList
          })
        } else {
          console.log("User cancelled copy order action.");
        }
      });


    },

    onTriggerDataPanelValue(event) {
      console.log("Value event");
      console.log(event);
    },

    runMassAction(event) {
      const action = event.action.action;
      const items = event.items; // Array of guids

      if (action === "delete-orders") {
        if (items && items.length > 0) {
          this.removeOrders(null, true, this.commonModule.centralInstance);
        }
      }
    },
    editOrderGeneratorView(order) {
      console.log("Editing order details for order: ", order);

      const payload = {
        orderGroupGuid: order.groupGuid,
      }
      this.packagesModule.acquirePackageOrderViewLock(payload).then((response) => {
        if (!response.data.payload.acquired) {
          Swal.fire(
              "Zamówienie otwarte przez innego użytkownika",
              "Aktualnie używa: " + (response.data.payload.ownerUserId || "ktoś inny"),
              "warning"
          );
        }else{
          this.$router.push({name: 'PackagesManagerOrdersGeneratorStage', query: {editOrderGroupGuid: order.groupGuid}})
        }

      });


    },
    goToOrderRealisationView(order) {
      console.log("Going to order details for order: " + order.guid);
      this.$router.push({
        name: 'PackagesManagerOrdersRealisationLevelStage',
        query: {orderGroupGuid: order.groupGuid},
        params: {orderGroupGuid: order.groupGuid}
      });
    },
    openOrderExcelFile(orderGuidToOpen) {
      var requestPayload = {
        orderGuid: orderGuidToOpen,
      };
      this.packagesModule.httpOpenOrderExcelFile(requestPayload);
    },
    removeOrders(orderGuidToRemove, removeAllChecked, isOrderCentral) {
      if (isOrderCentral && this.commonModule.centralInstance === false) {
        Swal.fire({
          title: "Błąd",
          text: "Nie można usunąć zamówienia centralnego, z poziomu lokalnej instancji aplikacji.",
          icon: "error",
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "OK",
        });
        return;
      }

      var additionalWarning = "";
      if (isOrderCentral) {
        additionalWarning = "Zamówienie jest już opublikowane, zniknie więc również z widoku dotyczącej go apteki."
      }
      var warningTitle = "Czy na pewno chcesz usunąć to zamówienie?";
      if (removeAllChecked) {
        warningTitle = "Czy na pewno chcesz usunąć zaznaczone zamówienia?";
      }

      var warningText = additionalWarning + " Proces usuwania jest nieodwracalny.";

      Swal.fire({
        title: warningTitle,
        text: warningText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak",
        dangerMode: true,
      }).then((proceed) => {
        if (proceed.value) {
          this.removeOrderByGuid(orderGuidToRemove, removeAllChecked);
        }
      });
    },
    removeOrderByGuid(orderGuidToRemove, removeAllChecked) {
      var ordersGroupGuidsToRemove = [orderGuidToRemove];
      if (removeAllChecked === true) {
        ordersGroupGuidsToRemove = this.selectedItems ? this.selectedItems.map((item) => item.groupGuid) : [];

      }
      console.log("Removing all checked orders: ");
      console.log(ordersGroupGuidsToRemove);
      var requestPayload = {
        ordersGroupGuids: ordersGroupGuidsToRemove,
      };
      this.packagesModule.httpRemovePackageOrdersForGroupGuids(requestPayload).then(() => {
        this.selectedItems = []; // Clear selection after delete
        this.refreshPackageOrdersList();
      });
    },
    getSearchTypeFromKey(key) {
      if (key === "orderName") return 0;
      if (key === "itemName") return 1;
      if (key === "itemBloz") return 2;
      return 0; // Default
    },
    refreshPackageOrdersList() {
      this.commonModule.httpGetDrugstoresNameMap().then(() => {
        this.refreshGroupedOrdersList();
      })
    },
    openOrderDetailsModal(passedOrderGroupGuid) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o zamówieniu.");
      this.packagesModule.httpGetPackageGroupOrderByGuid({orderGroupGuid: passedOrderGroupGuid}).then((response) => {

        const fetchedOrder = response.data.payload
        const orderCreationDate = new Date(fetchedOrder.orderCreationDate).toLocaleString('sv', {timeZone: 'Europe/Warsaw'}).split(' ')[0]; // format yyyy-mm-dd
        this.currentEditedGroupOrder = fetchedOrder
        this.currentEditedGroupOrder.orderCreationDate = orderCreationDate;
        this.lazyloaderModule.setDisplayLazyLoader(false);
        console.log("Fetched order for details modal: ", this.currentEditedGroupOrder);
        this.showOrderDetailsModal = true;
      })

    },
    closeDetailsModal(event) {
      if (event === false) {
        this.currentEditedGroupOrder = null;
      }
      this.showOrderDetailsModal = event
    },

    saveOrder(result) {
      console.log("Saving order: ", result);
      packagesHelperMethods.saveGroupOrderFormData(result, this.currentEditedGroupOrder).then((response) => {
        this.currentEditedGroupOrder = response.data.payload;
        this.refreshPackageOrdersList();
      })

      this.showOrderDetailsModal = false
    },


    exportAndSendEmail(orderGroupGuid) {

      this.packagesModule.httpGetPackageGroupOrderByGuid({orderGroupGuid: orderGroupGuid}).then((response) => {
        const fetchedOrder = response.data.payload
        const orderCreationDate = new Date(fetchedOrder.orderCreationDate).toLocaleString('sv', {timeZone: 'Europe/Warsaw'}).split(' ')[0]; // format yyyy-mm-dd
        this.currentGroupOrderToSend = fetchedOrder
        this.currentGroupOrderToSend.orderCreationDate = orderCreationDate;
        this.exportAndSendEmailForGroupOrder(this.currentGroupOrderToSend).then((result) => {
          if (!result || !result.isConfirmed) {
            return;
          }
          this.refreshPackageOrdersList();
        })
      })

    },
    exportAndSendEmailForGroupOrder(groupOrder) {
      return packagesHelperMethods.exportGroupOrderToFile(groupOrder, "XLS", true, false).then((response) => {
        log.log(response);
        if (response.isConfirmed) {
          this.mailContent = {
            sendMailDialogTitle: response.sendMailDialogTitle,
            mailMessage: response.mailMessage,
            mailSubject: response.mailSubject,
            mailTo: response.mailTo,
            mailCc: response.mailCc,
            mailAttachmentName: response.mailAttachmentName
          }

          this.packagesModule.httpGetGroupOrderEMailHistory({orderGroupGuid: groupOrder.groupGuid}).then((response) => {
            if (response && response.data.payload.length > 0) {
              // get first of response.data.payload (ordered by send date)
              response.data.payload.sort((a, b) => new Date(b.sendDate) - new Date(a.sendDate));
              // getting last email
              const lastEmail = response.data.payload[0];

              this.showSendMailAlert = true;
              this.sendMailAlertType = "warning";
              this.sendMailAlertContent = "Wiadomość email z tym zamówieniem została już wysłana do aptek dnia " + packagesHelperMethods.formatDatetimeToLocaleFormat(lastEmail.sendDate);
            }

            this.showSendMailModal = true;
            return new Promise((resolve) => {
              resolve({isConfirmed: true});
            });
          })
          return new Promise((resolve) => {
            resolve({isConfirmed: false});
          });

        }
      });

    },
    sendEmailWithPackageOrderData(emailData) {
      log.log(emailData);
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Wysyłanie wiadomości email z zamówieniem...");

      var emailPayload = {
        mailMessage: emailData,
        orderGroupGuid: this.currentGroupOrderToSend.groupGuid

      }

      this.packagesModule.httpSendEmailWithWithGroupOrderData(emailPayload).then((response) => {
        this.showSendMailModal = false;
        this.currentGroupOrderToSend = null;
        return apiRequestsHelper.handleResponseWithDialogs(response, true);
      })

    },

    getPackagesOrdersForLocalInstance() {
      this.packagesModule.setPackageOrders([]);

      // Map SearchBar2 request to backend expected payload
      const searchPayload = {
        searchPhrase: this.searchRequest.searchPhrase || "",
        type: this.getSearchTypeFromKey(this.searchRequest.searchKey)
      };

      var requestPayload = {
        currentPage: this.currentPage,
        searchAndFilterRequest: searchPayload,
        sortingKey: this.sortingKey,
        sortingDirection: this.sortingDirection
      };

      this.performFetch(requestPayload);
    },
    refreshGroupedOrdersList() {
      this.packagesModule.setPackageOrders([]);
      this.dataPanelData = null;

      // Map SearchBar2 request to backend expected payload
      const searchPayload = {
        searchPhrase: this.searchRequest.searchPhrase || "",
        type: this.getSearchTypeFromKey(this.searchRequest.searchKey)
      };

      var requestPayload = {
        groupGuid: null,
        currentPage: this.currentPage,
        searchAndFilterRequest: searchPayload,
        sortingKey: this.sortingKey,
        sortingDirection: this.sortingDirection,
        grouped: true
      };

      this.performFetch(requestPayload)
    },
    performFetch(requestPayload) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      return this.packagesModule.httpGetPackageOrdersPaging(requestPayload).then(() => {
        this.packageOrders = JSON.parse(JSON.stringify(this.packagesModule.getPackageOrders));
        this.packagesModule.setOrdersChangesSeenState({});
        var ordersGuidsToGetChangesState = this.packageOrders.map((o) => o.guid);

        var childRequestPayload = {
          ordersGuids: ordersGuidsToGetChangesState,
        };
        // Background fetch extras
        this.packagesModule.httpGetOrderChangesSeenStatus(childRequestPayload);
        this.packagesModule.httpGetReportLastSentDatesForOrders(childRequestPayload);

        this.updateTableData();
        this.lazyloaderModule.setDisplayLazyLoader(false);
      }).catch(e => {
        this.lazyloaderModule.setDisplayLazyLoader(false);
        console.error(e);
      });
    },
    getShareBtnClass(isCentralOrder) {
      if (isCentralOrder) {
        return "btn btn-success table-actions-button edit-button";
      } else {
        return "btn btn-warning table-actions-button edit-button";
      }

    },
    getShareBtnInnerHtml(isCentralOrder) {
      if (isCentralOrder) {
        return "\n" +
            "                                <div\n" +
            "                                        data-placement=\"top\"\n" +
            "                                        v-b-tooltip.hover\n" +
            "                                        title=\"Zamówienie udostępnione aptekom\"\n" +
            "                                > <i class=\"fas fa-globe\"/> Opublikuj</div>"
      } else {
        return " <div\n" +
            "                                        data-placement=\"top\"\n" +
            "                                        v-b-tooltip.hover\n" +
            "                                        title=\"Udostępnij to zamówienie aptekom\"\n" +
            "                                >\n" +
            "                                    <i class=\"fas fa-sitemap\"/> Opublikuj</div>"
      }

    },


    changeShareBtnView(buttonElementRef) {
      const orderShareBtn = this.$refs[buttonElementRef]
      if (orderShareBtn && orderShareBtn.length > 0 && orderShareBtn[0]) {
        orderShareBtn[0].className = this.getShareBtnClass(true);
        orderShareBtn[0].innerHTML = this.getShareBtnInnerHtml(true);
      }
    },
    openShareForm(order, buttonElementRef) {
      packagesHelperMethods.openShareForm(order).then((response) => {
        if (response && response.isConfirmed) {
          this.changeShareBtnView(buttonElementRef);
        }
      });

    },

    updateTableData() {
      // Process data to match columns if needed
      // e.g. actions
      this.packageOrders.forEach(order => {
        const orderStatusObj = this.packagesModule.getPackageOrderStatusMapWithDescription[order.orderStatus.toString().toLowerCase()];
        order.orderStatus = orderStatusObj.text;

        if (!order.actions) {
          order.actions = [];
        }

      });
      this.tableData["headers"] = this.availableHeaders;
      this.tableData["massActions"] = this.tableMassActions;
      this.tableData["data"] = this.packageOrders;
      this.refreshTable = !this.refreshTable; // Trigger re-render if needed
    },

    handleKeyDown(event){
      const target = event.target;
      const tagName = target?.tagName?.toLowerCase();

      const isTypingElement =
          tagName === "input" ||
          tagName === "textarea" ||
          tagName === "select" ||
          target?.isContentEditable;

      if (isTypingElement) {
        return;
      }


      if(event.ctrlKey){
        return
      }

      event.preventDefault()
      if(event.altKey){
        this.handleKeyDownWithAlt(event);
      } else {
        this.handleKeyDownWithoutAlt(event);
      }

    },
    handleKeyDownWithAlt(event){
      console.log("Alt pressed",event);
      const allowedKeys = ['d']
      if(!allowedKeys.includes(event.key)){
        return
      }
      event.preventDefault();
      switch (event.key) {
        case 'd':
          if(this.dataPanelData){
            this.copyExistingOrderToNewWitWarning(this.dataPanelData)
          }
          break
      }

    },
    handleKeyDownWithoutAlt(event) {
      const allowedKeys = ['F2', 'F3', 'F4', 'F5', 'F6', 'F7','F8']

      if (!allowedKeys.includes(event.key)) {
        return
      }

      event.preventDefault()

      switch (event.key) {
        case 'F2':
          this.openOrdersGeneratorForm();
          break
        case 'F3':
          if(this.dataPanelData){
            this.openOrderDetailsModal(this.dataPanelData.groupGuid)
          }
          break
        case 'F4':
          if(this.dataPanelData){
            this.goToOrderRealisationView(this.dataPanelData)
          }
          break
        case 'F5':
          if(this.dataPanelData){
            this.copyExistingOrderToNewWitWarning(this.dataPanelData)
          }
          break
        case 'F6':
          if(this.dataPanelData){
            this.exportAndSendEmail(this.dataPanelData.groupGuid)
          }
          break
        case 'F7':
          if(this.dataPanelData){
            this.removeOrders(this.dataPanelData.groupGuid, false, this.commonModule.centralInstance);
          }
          break
        case 'F8':
          if(this.selectedItems && this.selectedItems.length > 0){
            this.removeOrders(null, true, this.commonModule.centralInstance);
          }
          break
      }
    },


  },
  watch: {
    currentPage() {
      this.refreshPackageOrdersList();
    },
  },
  created() {
    this.simplepharmAuth.refreshToken().then(()=>{
      this.refreshPackageOrdersList();
    })
  },
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-package me-1"></i> Zamówienia centralne`)
    window.addEventListener('keydown', this.handleKeyDown)

  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
};
</script>

<style scoped>
.package-orders-table-container {
  margin-top: 20px;
}

.package-orders-generator-site {

}
</style>
